var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggler({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 3.59995C4.5 3.10291 4.90296 2.69995 5.4 2.69995H17.1C17.597 2.69995 18 3.10291 18 3.59995C18 4.09699 17.597 4.49995 17.1 4.49995H5.4C4.90296 4.49995 4.5 4.09696 4.5 3.59995ZM17.1 8.09995H0.9C0.402961 8.09995 0 8.50295 0 8.99995C0 9.49699 0.402961 9.89995 0.9 9.89995H17.1C17.597 9.89995 18 9.49699 18 8.99995C18 8.50295 17.597 8.09995 17.1 8.09995ZM17.1 13.5H9C8.503 13.5 8.1 13.9029 8.1 14.4C8.1 14.897 8.503 15.3 9 15.3H17.1C17.597 15.3 18 14.897 18 14.4C18 13.9029 17.597 13.5 17.1 13.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggler);
export default __webpack_public_path__ + "static/media/toggler.322ce28ec20d96bd4b570de4638f80ca.svg";
export { ForwardRef as ReactComponent };